import { post as jsonPost } from '../../../../../shared/js/json-fetch'
import useTimeout from '../../../../../shared/js/use-timeout'
import React from 'react'
import { useState } from 'react'
import type { FlashProps } from '../../../shared/Module'
import type { ChangeEvent, SyntheticEvent } from 'react'

interface DiscountFormProps {
  onChange: Function
  url: string
  // This one is for testing purpose.  Post function is injected from json-fetch
  // module using default params
  post?: Function
}

const DiscountForm = ({
  onChange,
  post = jsonPost,
  url,
}: DiscountFormProps) => {
  const [discountsHidden, setDiscountsHidden] = useState(true)
  const [flash, setFlash] = useState<FlashProps | null>(null)
  const [disabled, setDisabled] = useState(false)
  const [ticketCode, setTicketCode] = useState('')

  // Remove flash messages after 5 seconds
  useTimeout(() => setFlash(null), 5000)

  return (
    <dl className='accordion discount-accordion'>
      <dt
        aria-controls='disclosure-discount'
        aria-expanded={discountsHidden}
        onClick={toggleDiscount}
      >
        Ajouter un code avoir
      </dt>
      <dd
        id='disclosure-discount'
        className='c-voucher__content'
        hidden={discountsHidden}
      >
        <fieldset className='promo-code'>
          <label className='visually-hidden' htmlFor='voucher'>
            Code avoir
          </label>
          <p>
            <input
              aria-required='true'
              disabled={disabled}
              id='ticket-code'
              name='ticket_code'
              onChange={handleTicketCodeChange}
              placeholder='Code avoir'
              type='text'
              value={ticketCode}
            />
            <button
              className='mlc-btn mlc-btn-type-1'
              onClick={applyTicketCode}
              disabled={disabled || ticketCode.trim() === ''}
              data-testid='apply-ticket-code'
            >
              Valider
            </button>
          </p>
        </fieldset>
        {flash && (
          <div className={`c-message c-message--${flash.kind}`}>
            {flash.message}
          </div>
        )}
      </dd>
    </dl>
  )

  // Request server then print applied discount
  // or error message when not applicatble
  async function applyTicketCode(event: SyntheticEvent) {
    event.preventDefault()
    setDisabled(true)

    // Send data to server
    const { data, flash } = await post(url, {
      ticket_code: ticketCode,
    })

    setDisabled(false)
    if (flash) {
      setFlash(flash)
    }
    if (data) {
      setTicketCode('')
      onChange(data)
    }
  }

  function handleTicketCodeChange({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) {
    setTicketCode(value)
  }

  function toggleDiscount() {
    setDiscountsHidden(!discountsHidden)
  }
}
export default DiscountForm
